import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-transparent border-b border-gold/40 text-cream placeholder-cream/40 py-3 focus:outline-none focus:border-gold transition-colors duration-300";

  return (
    <div className="min-h-screen bg-navy-deep grain topo flex items-center justify-center px-6">
      <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-gold/10 blur-[100px]" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 w-full max-w-md border border-gold/25 rounded-2xl p-9 md:p-11 bg-white/[0.03] backdrop-blur-sm"
      >
        <div className="flex items-center gap-3 mb-8">
          <img src="/crane_light.png" alt="" className="h-12 w-12 object-contain" />
          <div className="leading-none">
            <p className="font-display text-xl text-cream tracking-wide">KINGDOM</p>
            <p className="text-[9px] text-gold tracking-luxe mt-1">ADVANCEMENT</p>
          </div>
        </div>

        <p className="text-gold text-xs uppercase tracking-luxe mb-2">Private Access</p>
        <h1 className="font-display text-4xl text-cream mb-8">Leads Dashboard</h1>

        <form onSubmit={submit} data-testid="login-form" className="space-y-6">
          <input data-testid="login-email" type="email" className={field} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" className={field} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          {err && <p className="text-red-300 text-sm" data-testid="login-error">{err}</p>}
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-gold text-navy-deep font-semibold uppercase tracking-[0.15em] text-xs px-8 py-4 rounded-full hover:bg-gold-light transition-colors duration-300 disabled:opacity-70"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : <><Lock size={15} /> Sign In</>}
          </button>
        </form>

        <a href="/" className="block mt-8 text-center text-cream/50 text-xs uppercase tracking-luxe hover:text-gold transition-colors">
          ← Back to site
        </a>
      </motion.div>
    </div>
  );
}
